import { defaultAbiCoder } from '@ethersproject/abi'
import { getCreate2Address } from '@ethersproject/address'
import { keccak256 } from '@ethersproject/solidity'
import { Token } from '@uniswap/sdk-core'
import { FeeAmount } from '@uniswap/v3-sdk'

export function computePoolAddressWithVersion({
  factoryAddress,
  tokenA,
  tokenB,
  fee,
  version,
  initCodeHash,
}: {
  factoryAddress: string
  tokenA: Token
  tokenB: Token
  fee: FeeAmount
  version: number | bigint
  initCodeHash: string
}): string {
  const [token0, token1] = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA]

  const salt = keccak256(
    ['bytes'],
    [
      defaultAbiCoder.encode(
        ['address', 'address', 'uint24', 'uint256'],
        [token0.address, token1.address, fee, version]
      ),
    ]
  )

  return getCreate2Address(factoryAddress, salt, initCodeHash)
}
